"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AircraftLandingCircleLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AircraftLandingCircleLinear = function AircraftLandingCircleLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.072 17.366a1 1 0 011.029-.327l3.863 1.035a1 1 0 01.539.362l6.674 8.817 7.88 2.112a3.5 3.5 0 11-1.813 6.761l-19.12-5.123a9.107 9.107 0 01-6.45-6.48l-.855-3.246a1 1 0 011.226-1.22l2.898.776a1 1 0 01.607.466l1.207 2.09 5.227 1.401-3.044-6.353a1 1 0 01.132-1.071zm2.611 2.167l3.044 6.354a1 1 0 01-1.16 1.398l-7.728-2.07a1 1 0 01-.607-.467l-1.207-2.09-.833-.224.416 1.58a7.107 7.107 0 005.033 5.057l19.121 5.123a1.5 1.5 0 00.776-2.898l-8.21-2.2a1 1 0 01-.538-.362l-6.675-8.817-1.432-.384z",
    fill: "url(#AircraftLandingCircleLinear_svg__AircraftLandingCircleLinear_svg__paint0_linear_17373_95642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 42a1 1 0 01-1 1H17a1 1 0 110-2h26a1 1 0 011 1z",
    fill: "url(#AircraftLandingCircleLinear_svg__AircraftLandingCircleLinear_svg__paint1_linear_17373_95642)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 30c0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30zm-2 0c0 15.464-12.536 28-28 28S2 45.464 2 30 14.536 2 30 2s28 12.536 28 28z",
    fill: "url(#AircraftLandingCircleLinear_svg__AircraftLandingCircleLinear_svg__paint2_linear_17373_95642)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "AircraftLandingCircleLinear_svg__AircraftLandingCircleLinear_svg__paint0_linear_17373_95642",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AircraftLandingCircleLinear_svg__AircraftLandingCircleLinear_svg__paint1_linear_17373_95642",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AircraftLandingCircleLinear_svg__AircraftLandingCircleLinear_svg__paint2_linear_17373_95642",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  }))));
};

exports.AircraftLandingCircleLinear = AircraftLandingCircleLinear;
var _default = AircraftLandingCircleLinear;
exports.default = _default;